import { ICommandBase } from "@Alternatives/cqrs";

export interface ICommand { }

export class AssignUserCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Alternatives.Assignments.Commands.AssignUserCommandV1, TCh.Domain.Alternatives';

	WorkspaceId: number;
	ProjectId: number;
	Id: string;
	UserId: number;

	constructor(workspaceId: number, projectId: number, alternativeId: string, userId: number)
	{
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.Id = alternativeId;
		this.UserId = userId;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Alternatives.Assignments.Commands.AssignUserCommandV1, TCh.Domain.Alternatives';
	}
}

export class UnassignUserCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Alternatives.Assignments.Commands.UnassignUserCommandV1, TCh.Domain.Alternatives';

	WorkspaceId: number;
	ProjectId: number;
	Id: string;
	UserId: number;

	constructor(workspaceId: number, projectId: number, alternativeId: string, userId: number)
	{
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.Id = alternativeId;
		this.UserId = userId;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Alternatives.Assignments.Commands.UnassignUserCommandV1, TCh.Domain.Alternatives';
	}
}


export class BulkAssignUsersCommandV1 implements ICommandBase
{
	$type: string = 'TCh.Domain.Alternatives.Assignments.Commands.BulkAssignUsersCommandV1, TCh.Domain.Alternatives';

	WorkspaceId: number;
	ProjectId: number;
	Id: string;
	Ids: string[];
	UserIds: number[];

	constructor(workspaceId: number, projectId: number, alternativeIds: string[], userIds: number[])
	{
		this.WorkspaceId = workspaceId;
		this.ProjectId = projectId;
		this.Id = "";
		this.Ids = alternativeIds;
		this.UserIds = userIds;
	}

	static matchType(cmd: ICommandBase)
	{
		return cmd.$type === 'TCh.Domain.Alternatives.Assignments.Commands.BulkAssignUsersCommandV1, TCh.Domain.Alternatives';
	}
}

//
